import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import { getPage } from '../services/pageService';

const Prayers = () => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadPrayers = async () => {
      const page = await getPage('prayers');
      setContent(page?.contentHtml || '');
      setIsLoading(false);
    };
    loadPrayers();
  }, []);

  return (
    <>
      <div className="container-fluid page-top">
        <div className="container">
          <div className="row">
            <h2>Oraciones</h2>
          </div>
        </div>
      </div>
      <div className="container-fluid bg-history">
        <div className="container history">
          <div className="row">
            <div className="col-12">
              <div className="py-4">
                {isLoading ? (
                  <LoadingSpinner label="Cargando oraciones..." />
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Prayers;